"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var router_1 = require("@angular/router");
var material_1 = require("@angular/material");
var lodash_1 = require("lodash");
var paystub_service_1 = require("./paystub.service");
var paystub_filters_dialog_component_1 = require("./paystub-filters-dialog.component");
var paystub_pay_type_dialog_component_1 = require("./paystub-pay-type-dialog.component");
var index_1 = require("../shared/dialogs/index");
var api_service_1 = require("../shared/api.service");
var export_dialog_component_1 = require("../shared/export-dialog/export-dialog.component");
var rxjs_1 = require("rxjs");
var PaystubsComponent = /** @class */ (function () {
    function PaystubsComponent(route, router, paystubService, dialog) {
        this.route = route;
        this.router = router;
        this.paystubService = paystubService;
        this.dialog = dialog;
        this.paystubs = [];
        this.loading = true;
        this.errors = [];
        this.search = '';
        this.sortAsc = true;
        this.filters = [];
        this.count = 0;
        this.selectedCount = {
            draft: 0,
            paid: 0
        };
        this.allSelected = {
            draft: false,
            paid: false
        };
        this.selectedPaystubs = {
            draft: [],
            paid: []
        };
        this.excludePaystubs = {
            draft: [],
            paid: []
        };
        this.state = 'draft';
        this.dropdownOptions = {
            draft: [
                { name: 'Export', button: true }
            ],
            paid: [
                { name: 'Export', button: true },
                { name: 'Download', button: true }
            ]
        };
        this.menuOptions = [
            { name: 'Edit', action: 'edit', link: true, external: false },
            { name: 'Mark as Paid', action: 'mark_as_paid', link: false, external: false },
            { name: 'View', action: 'view', link: true, external: true },
            { name: 'Unlock', action: 'unlock', link: false, external: false },
            { name: 'Download', action: 'download', link: true, external: true },
            { name: 'Export', action: 'export', link: false, external: false },
        ];
        this.contextMenuEventSubject = new rxjs_1.Subject();
    }
    PaystubsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.forEach(function (params) {
            _this.loading = true;
            var mock = params['mock'];
            _this.search = params['search'] || '';
            if (mock) {
                _this.paystubs = _this.paystubService.getMockPaystubs(10);
                _this.loading = false;
            }
            else {
                _this.sortBy = params.sortBy ? params.sortBy : 'created_at';
                _this.sortAsc = params.sortAsc ? (params.sortAsc === 'true') : false;
                _this.getPaystubs();
            }
        });
        this.route.params.subscribe(function (params) {
            _this.state = params['state'];
            _this.getPaystubs();
        });
    };
    PaystubsComponent.prototype.onScroll = function (e) {
        var _this = this;
        if (!this.loading &&
            e.target.scrollTop > e.target.scrollHeight - e.target.clientHeight * 3) {
            var o = this.paystubService.getNext();
            if (o) {
                this.loading = true;
                o.subscribe(function (paystubs) {
                    _this.paystubs = _this.paystubs.concat(paystubs);
                    _this.loading = false;
                }, function (err) { return _this.errors = api_service_1.parseErrors(err); }, function () {
                    _this.loading = false;
                });
            }
        }
    };
    PaystubsComponent.prototype.getPaystubs = function (query, append) {
        var _this = this;
        if (query === void 0) { query = {}; }
        if (append === void 0) { append = false; }
        if (!append) {
            this.paystubs = [];
        }
        this.loading = true;
        var order = (this.sortAsc ? '' : '-') + this.sortBy;
        var filters = this.filters.reduce(function (acc, filter) {
            return __assign({}, acc, filter.query);
        }, {});
        if (this.paystubsReq) {
            this.paystubsReq.unsubscribe();
        }
        this.paystubsReq = this.paystubService.getPaystubs(__assign({ ordering: order, search: this.search, sent: this.state === 'draft' ? 'False' : 'True' }, filters, query)).subscribe(function (paystubs) {
            if (append) {
                _this.paystubs = _this.paystubs.concat(paystubs);
            }
            else {
                _this.paystubs = paystubs;
            }
            _this.count = _this.paystubService.count;
            _this.loading = false;
        }, function (err) { return _this.errors = api_service_1.parseErrors(err); }, function () {
            _this.loading = false;
        });
    };
    PaystubsComponent.prototype.sort = function (sortKey) {
        if (this.sortBy === sortKey) {
            this.sortAsc = !this.sortAsc;
        }
        this.sortBy = sortKey;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: __assign({}, this.route.snapshot.queryParams, { sortBy: this.sortBy, sortAsc: this.sortAsc })
        });
        this.loading = true;
        this.getPaystubs({ ordering: (this.sortAsc ? '' : '-') + this.sortBy });
    };
    PaystubsComponent.prototype.customSort = function (sortParameter, sortKey) {
        var _a;
        if (this.sortParameter === sortParameter && this.sortBy === sortKey) {
            this.sortAsc = !this.sortAsc;
        }
        this.sortBy = sortKey;
        this.sortParameter = sortParameter;
        this.loading = true;
        this.getPaystubs((_a = {}, _a[this.sortParameter] = (this.sortAsc ? '' : '-') + this.sortBy, _a));
    };
    PaystubsComponent.prototype.changeSearch = function (term) {
        this.search = term || '';
        var queryParams = Object.assign({}, this.route.snapshot.queryParams);
        queryParams['search'] = this.search;
        this.router.navigate(['paystubs', 'filter', this.state], { queryParams: queryParams });
        this.getPaystubs();
    };
    PaystubsComponent.prototype.expandSearch = function () {
        var _this = this;
        this.loading = true;
        setTimeout(function () {
            _this.search = '';
            _this.changeSearch();
        }, 1000);
    };
    PaystubsComponent.prototype.openFilters = function () {
        var _this = this;
        var dialog = this.dialog.open(paystub_filters_dialog_component_1.PaystubFiltersDialogComponent, {
            width: '430px'
        });
        dialog.componentInstance.callback = function (res) { return _this.filterChanges(res); };
        var startDate = lodash_1.get(lodash_1.find(this.filters, { key: 'startDate' }), 'value');
        if (startDate && startDate.hasOwnProperty('year')) {
            dialog.componentInstance.model.startDate = startDate;
        }
        var endDate = lodash_1.get(lodash_1.find(this.filters, { key: 'endDate' }), 'value');
        if (endDate && endDate.hasOwnProperty('year')) {
            dialog.componentInstance.model.endDate = endDate;
        }
        dialog.componentInstance.model.job = lodash_1.get(lodash_1.find(this.filters, { key: 'job' }), 'value');
        dialog.componentInstance.model.customer = lodash_1.get(lodash_1.find(this.filters, { key: 'customer' }), 'value');
        dialog.componentInstance.model = this.filters.reduce(function (acc, filter) {
            acc[filter.key] = filter.value;
            return acc;
        }, {});
        this.filtersDialog = dialog.componentInstance;
    };
    PaystubsComponent.prototype.filterChanges = function (filterRes) {
        // Callback from the filter dialog. Creates a collection of filters with the format: {key, value, query},
        // where 'key' is the filter type such as 'customer',
        // 'value' is the original object for the options that was select from the dropdown,
        // and 'query' is an object representing the query fragment associated with that filter setting.
        var queryKeys = {
            customer: 'customer_organization',
            job: 'job',
            sent: 'sent'
        };
        var falseyFilters = [];
        this.filters = Object.keys(filterRes).map(function (key) {
            var query = {};
            var value = filterRes[key];
            var displayValue;
            if (typeof (value) === 'boolean') {
                if (key === 'incomplete' && value) {
                    displayValue = value.toString();
                    displayValue = displayValue.charAt(0).toUpperCase() + displayValue.slice(1);
                    value = !value;
                    var filterValue = value.toString();
                    filterValue = filterValue.charAt(0).toUpperCase() + filterValue.slice(1);
                    query[queryKeys[key]] = filterValue;
                }
                else if (value) {
                    value = value.toString();
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                    query[queryKeys[key]] = value;
                }
            }
            else {
                query[queryKeys[key]] = filterRes[key] && filterRes[key].id;
            }
            var filter = {
                key: key,
                value: displayValue || value,
                query: query
            };
            if (filter.value === 'False' || !filter.value) {
                falseyFilters.push(filter);
            }
            return filter;
        });
        this.filters = lodash_1.difference(this.filters, falseyFilters);
        this.getPaystubs();
    };
    PaystubsComponent.prototype.removeFilter = function (filter) {
        lodash_1.remove(this.filters, filter);
        this.getPaystubs();
    };
    PaystubsComponent.prototype.menuAction = function (action, paystub) {
        switch (action) {
            case 'mark_as_paid':
                this.sendPaystub(paystub);
                break;
            case 'export':
                this.createExport([paystub.id]);
                break;
            case 'unlock':
                this.unlockPaystub(paystub);
                break;
        }
    };
    PaystubsComponent.prototype.unlockPaystub = function (paystub) {
        var _this = this;
        this.confirmDialog = this.dialog.open(index_1.RuckitConfirmDialogComponent, {
            width: '430px',
            height: '250px'
        });
        this.confirmDialog.componentInstance.attributes = {
            title: 'Unlock Paystub?',
            body: 'This paystub will be unlocked and can be modified.',
            close: 'Cancel',
            accept: 'Unlock'
        };
        this.confirmDialog.afterClosed().subscribe(function (dialogResult) {
            if (dialogResult) {
                _this.loading = true;
                _this.paystubService.unlock(paystub).subscribe(function (res) {
                    _this.getPaystubs();
                }, function (err) {
                    _this.errors = api_service_1.parseErrors(err);
                    _this.loading = false;
                });
            }
            _this.confirmDialog = null;
        });
    };
    PaystubsComponent.prototype.sendPaystub = function (paystub) {
        var _this = this;
        if (!paystub.paymentType) {
            this.capturePaymentType(paystub);
        }
        else {
            this.loading = true;
            this.paystubService.send(paystub).subscribe(function () {
                paystub.sent = true;
                _this.loading = false;
                _this.getPaystubs();
            }, function (err) {
                _this.errors = api_service_1.parseErrors(err);
                _this.loading = false;
            });
        }
    };
    PaystubsComponent.prototype.capturePaymentType = function (paystub) {
        var _this = this;
        this.paymentTypeDialog = this.dialog.open(paystub_pay_type_dialog_component_1.PaystubPayTypeDialogComponent, {
            width: '430px'
        });
        this.paymentTypeDialog.componentInstance.paystub = paystub;
        this.paymentTypeDialog.componentInstance.callback = function (res) {
            paystub.paymentType = res.paymentType;
            _this.sendPaystub(paystub);
        };
    };
    PaystubsComponent.prototype.createExport = function (paystubs, section) {
        var _this = this;
        if (section === void 0) { section = null; }
        var scope = {};
        var params = new http_1.HttpParams();
        if (paystubs && paystubs.length) {
            Object.assign(scope, { paystubs: paystubs });
        }
        else if (this.allSelected) {
            Object.assign(scope, { excludePaystubs: this.excludePaystubs[section] });
            Object.keys(this.filters).map(function (key) {
                if (_this.filters[key]) {
                    var query_1 = _this.filters[key]['query'];
                    Object.keys(query_1).map(function (queryKey) {
                        params = params.set(queryKey, query_1[queryKey]);
                    });
                }
            });
            params = params.set('search', this.search);
            params = params.set('sent', this.state === 'draft' ? 'False' : 'True');
        }
        this.dialog.open(export_dialog_component_1.ExportDialogComponent, {
            width: '430px',
            data: {
                type: 'paystubs',
                buttonText: 'Export Data to CSV',
                params: params,
                scope: scope,
                service: this.paystubService
            }
        });
    };
    PaystubsComponent.prototype.createDownload = function (paystubs, section) {
        var _this = this;
        if (section === void 0) { section = null; }
        var scope = {};
        var params = new http_1.HttpParams();
        if (paystubs && paystubs.length) {
            Object.assign(scope, { paystubs: paystubs });
        }
        else if (this.allSelected) {
            Object.assign(scope, { excludePaystubs: this.excludePaystubs[section] });
            Object.keys(this.filters).map(function (key) {
                if (_this.filters[key]) {
                    var query_2 = _this.filters[key]['query'];
                    Object.keys(query_2).map(function (queryKey) {
                        params = params.set(queryKey, query_2[queryKey]);
                    });
                }
            });
            params = params.set('search', this.search);
            params = params.set('sent', this.state === 'draft' ? 'False' : 'True');
        }
        this.paystubService.downloadPdfs(scope, params).subscribe(function () {
            _this.confirmDialog = _this.dialog.open(index_1.RuckitConfirmDialogComponent, {
                width: '430px',
                height: '250px'
            });
            _this.confirmDialog.componentInstance.attributes = {
                title: 'Download Link Sent',
                body: 'Your zip file with the selected paystub data is on its way to your inbox',
                close: 'Close',
                accept: null
            };
            _this.loading = false;
        }, function (err) {
            _this.errors = api_service_1.parseErrors(err);
            _this.loading = false;
        });
    };
    PaystubsComponent.prototype.selector = function (event, section, paystub) {
        if (section === void 0) { section = 'draft'; }
        if (paystub === void 0) { paystub = null; }
        if (paystub) {
            if (!event.target.checked) {
                paystub.selected = false;
                lodash_1.pull(this.selectedPaystubs[section], paystub.id);
                if (this.allSelected) {
                    this.excludePaystubs[section].push(paystub.id);
                    this.selectedCount[section] = (this.count - this.excludePaystubs[section].length);
                }
                else {
                    this.selectedCount[section] = this.selectedPaystubs[section].length;
                }
            }
            else {
                paystub.selected = true;
                if (this.allSelected[section]) {
                    lodash_1.pull(this.excludePaystubs[section], paystub.id);
                    this.selectedCount[section] = (this.count - this.excludePaystubs[section].length);
                }
                else {
                    this.selectedPaystubs[section].push(paystub.id);
                    this.selectedCount[section] = this.selectedPaystubs[section].length;
                }
            }
        }
        else {
            if (!event.target.checked) {
                this.allSelected[section] = false;
                this.paystubs.forEach(function (_paystub) { _paystub.selected = false; });
                this.selectedCount[section] = 0;
            }
            else {
                this.allSelected[section] = true;
                this.selectedCount[section] = (this.count - this.excludePaystubs[section].length);
            }
            this.selectedPaystubs[section] = [];
            this.excludePaystubs[section] = [];
        }
    };
    PaystubsComponent.prototype.setSelectedAction = function (option, section) {
        switch (option.name) {
            case 'Export':
                this.createExport(this.selectedPaystubs[section], section);
                break;
            case 'Download':
                this.createDownload(this.selectedPaystubs[section], section);
                break;
        }
    };
    PaystubsComponent.prototype.openContextMenu = function (event, driverId) {
        this.contextMenuEventSubject.next({
            event: event,
            driverId: driverId
        });
    };
    return PaystubsComponent;
}());
exports.PaystubsComponent = PaystubsComponent;
